// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"111":"ac5e4cad","453":"a254284f"}[chunkId] + ".chunk.js";
};